import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 250px);
  padding: 24px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 12px;
`;

export const Description = styled.p`
  font-size: 15px;
  color: var(--text-secondary, #767F8D);
  line-height: 1.5;
  max-width: 260px;
  margin: 0 auto;
  font-weight: 400;
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px 32px;
  background: #fff;
  display: flex;
  justify-content: center;
`;
